import { CaretRightIcon, RobotIcon } from '@phosphor-icons/react'
import { useQuery } from '@tanstack/react-query'

import { toast } from '@utils/functions/notificationToast'

import type { ApprovalFlowRowProps } from './types'

import * as apiPreviewManagement from '@services/api/previewManagement'
import * as S from './styles'

const AUTO_SEND_COLOR = '#2299A5'
const AUTO_SEND_BACKGROUND = '#C6F6F5'

export const ApprovalFlowRow = ({ referenceDate, weekNumber, filters, onOpenUnitsList }: ApprovalFlowRowProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ['preview-management-automatic-sends', referenceDate, weekNumber, filters],
    queryFn: () =>
      apiPreviewManagement.getWeeklyStatusAutomaticSends({ referenceDate: referenceDate!, weekNumber: weekNumber!, ...filters }),
    enabled: !!referenceDate && weekNumber != null
  })

  const branches = data?.branches ?? []

  const handleViewList = () => {
    if (branches.length === 0) {
      toast.warning('Nenhum dado encontrado no momento')
      return
    }

    onOpenUnitsList({
      label: 'Envio Automático',
      icon: <RobotIcon size={18} />,
      color: AUTO_SEND_COLOR,
      background: AUTO_SEND_BACKGROUND,
      count: branches.length,
      units: branches.map((branch) => branch.branchDescription)
    })
  }

  return (
    <S.Container>
      <S.Description>
        <S.IconBox>
          <RobotIcon size={18} />
        </S.IconBox>
        Prévias enviadas de forma automática (via sistema)
        <S.CountBadge>{branches.length === 1 ? '1 Unid' : `${branches.length} Unids.`}</S.CountBadge>
      </S.Description>

      <S.ViewListButton
        onClick={handleViewList}
        style={{ opacity: isLoading ? 0.5 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}
      >
        Ver Lista
        <CaretRightIcon size={14} weight="bold" />
      </S.ViewListButton>
    </S.Container>
  )
}
